import { useState, useEffect } from "react";

export function useFormValidation(articlesSelected) {
  const [responsible, setResponsible] = useState(null)
  const [contributor, setContributor] = useState(null)
  const [DL, setDL] = useState(null)
  const [start, setStart] = useState(null)
  const [end, setEnd] = useState(null)
  const [actionSelected, setActionSelected] = useState("")
  const [description, setDescription] = useState("")
  const [isFormValid, setIsFormValid] = useState(false)

  useEffect(() => {
    const validSelection = articlesSelected.length > 0
    const validDates = start && end
    const validResponsibility = responsible && contributor
    const validAction = actionSelected && description

    setIsFormValid(validSelection && validDates && validResponsibility && validAction)
  }, [actionSelected ,articlesSelected, responsible, contributor, start, end, description])

  return {
    responsible,
    setResponsible,
    contributor,
    setContributor,
    DL,
    setDL,
    start,
    setStart,
    end,
    setEnd,
    actionSelected,
    setActionSelected,
    description,
    setDescription,
    isFormValid,
  }
}
